<template>
	<li>
		<a v-if="optionType === 'light'" href="#" class="uk-accordion-title">{{ displayNumber }}. Lights </a>
		<a v-if="optionType === 'pillow'" href="#" class="uk-accordion-title">{{ displayNumber }}. Pillow Guard </a>
		<div class="uk-accordion-content">
			<!-- Lights & Headboard -->
			<div class="lights-container">
				<template v-for="option in additional_options">
					<div v-if="showOption(option)" :key="'opt_' + option.id" class="uk-child-width-1-2@s uk-grid-collapse" uk-height-match=".light-description" uk-grid>
						<div @click.prevent="selectOption(option, false)">
							<div class="light-type" :class="{'selected' : !optionSelected(option)}">
								<p class="name">{{ option.disabled_name }}</p>
								<div class="light-wrapper">
									<img :src="imagePath(option.disabled_image)" :alt="option.disabled_name + ' image'">
									<div class="light-description" v-html="option.disabled_description"></div>
								</div>
							</div>
						</div>
						<div @click.prevent="selectOption(option, true)">
							<div class="light-type" :class="{'selected' : optionSelected(option)}">
								<p class="name">{{ option.name }} <span class="extra-price">{{ option.price | diffcurrency }}</span></p>
								<div class="light-wrapper">
									<img :src="imagePath(option.image)" :alt="option.name + ' image'">
									<div class="light-description" v-html="option.description"></div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
	</li>
</template>

<script>

import {mapState} from "vuex";

export default {
	name: "DeskLights",
	
	props: {
    optionType:{ //should be "light" or "pillow"
      type: String,
      default: "light"
    },
    displayNumber:{
      type: Number,
      default: 2
    }
  },
	components: {},
	data() {
		return {}
	},
	mounted() {
		
	},
	methods: {
    showOption(option){
      if(this.optionType === "light"){
        return option.name.toLowerCase().includes("light");
      }
      if(this.optionType === "pillow"){
        return option.name.toLowerCase().includes("pillow");
      }
      return false;
    },
    selectOption(option, setActive){
      let activeOptions = [];
      for(let i = 0; i < this.selected_options.length;++i){
        if(this.selected_options[i].id != option.id){ //re-store other options
          activeOptions.push(this.selected_options[i]);
        }
      }
      if(setActive){ // add if set to do so
        activeOptions.push(option);
      }
      this.$store.commit('setSelectedAdditionalOptions',activeOptions);
    },
    optionSelected(option){
      for(let i = 0; i < this.selected_options.length;++i){
        if(this.selected_options[i].id == option.id){
          return true;
        }
      }

      return false;
    },
    imagePath(image){
      if(image){
        return image.webPath + "/190/140";
      }

      return "/wp-content/themes/wallbeds/img/light-placeholder.jpg";
    },
  },
  computed:{
    ...mapState({
      wallbed : state => state.wallbed,
      desk_table_options : state => state.desk_table_options,
      additional_options : state => state.additional_options,
      selected_options : state => state.selected_options
    })
  },
	watch: {}
}
</script>